export default {
    en: {
        title: 'Orsero Tracking',
        sidebarTitle: 'Orsero Tracking',
        description:
            'React sidebar library with dropdown menus and unlimited number of nested submenus',
        dashboard: 'Dashboard',
        components: 'Components',
        dropdown: 'Dropdown',
        submenu: 'Submenu',
        multiLevel: 'Multi Level',
        collapsed: 'Collapsed',
        rtl: 'RTL',
        image: 'Background image',
        new: 'NEW',
        withPrefix: 'With Prefix',
        withSuffix: 'With Suffix',
        viewSource: 'Empty',
    },
    es: {
        title: 'Orsero Tracking',
        sidebarTitle: 'Orsero Tracking',
        description:
            'React sidebar library with dropdown menus and unlimited number of nested submenus',
        dashboard: 'Dashboard',
        components: 'Components',
        dropdown: 'Dropdown',
        submenu: 'Submenu',
        multiLevel: 'Multi Level',
        collapsed: 'Collapsed',
        rtl: 'RTL',
        image: 'Background image',
        new: 'NEW',
        withPrefix: 'With Prefix',
        withSuffix: 'With Suffix',
        viewSource: 'Empty',
        'Producto': 'Producto',
        'Productos': 'Productos',
        'Proveedor': 'Proveedor',
        'Proveedores': 'Proveedores',
        'Usuario': 'Usuario',
        'Usuarios': 'Usuarios',
        'Naviera': 'Naviera',
        'Navieras': 'Navieras',
        'Buscar': 'Buscar',
        'Limpiar': 'Limpiar',
        'Guardar': 'Guardar',
        'Eliminar': 'Eliminar',
        'Administrar': 'Administrar',
        'Este campo es requerido': 'Este campo es requerido',
        'Este nombre ya esta siendo usado': 'Este nombre ya esta siendo usado',
        'UserName no disponible': 'UserName no disponible',
        'Email no valido o no disponible':'Email no valido o no disponible',
        'Resultados por pagina': 'Resultados por página',
        'Nombre': 'Nombre',
        'Id': 'Id',
        'UserName': 'Usuario',
        'Password': 'Password',
        'Apellidos': 'Apellidos',
        'de': 'de',
        '¿Esta seguro de eliminar este elemento?': '¿Esta seguro de eliminar este elemento?',
        'Email': 'Email',
        'Destino': 'Destino',
        'Colillas': 'Colillas',
        'Contenedor': 'Contenedor',
        'Contenedores': 'Contenedores',
        'ContenedorSemanal': 'Contenedor semanal',
        'ContenedoresSemanales': 'Contenedores semanales',
        'Vapor': 'Vapor',
        'Vapores': 'Vapores',
        'Barco': 'Barco',
        'Barcos': 'Barcos',
        'Viaje': 'Viaje',
        'Viajes': 'Viajes',
        'Vapor Semanal': 'Vapor semanal',
        'Vapores Semanales': 'Vapores',
        'Year': 'Año',
        'Week': 'Semana',
        'TiposFruta': 'Tipos de fruta',
        'TipoFruta': 'Tipo de fruta',
        'EtiquetaEspecial': 'Observaciones adicionales',
        'FechaDeCarga': 'Fecha de carga',
        'FlujoDeTrabajo': 'Flujo de trabajo',
        'IngresoDePaletas': 'Ingreso de paletas',
        'Calibres': 'Calibres',
        'Semanas de trabajo': 'Semanas de carga',
        'Semanas': 'Semanas',
        'Semana': 'Semana',
        'Variantes': 'Varianti',
        'Carton': 'Carton',
        'Cartones': 'Cartones',
        'Generales': 'Generales',
        'Destinos': 'Destinos',
        'CajasPorPaleta': 'Cajas/Pal',
        'EtiquetasCore': 'Etiquetas core',
        'Etiquetas Core': 'Etiquetas core',
        'EtiquetaCore': 'Etiqueta CORE',
        'ResumenDeCargas': 'Resumen de cargas',
        'Reporte Despacho': 'Reporte Despacho',
        'Reportes': 'Reportes',
        'Paletizados': 'Paletizados',
        'Descargar': 'Descargar',
        'Reporte de despacho': 'Reporte de despacho',
        'Contenedores Semanales': 'Contenedores Semanales',
        'Fecha de empaque': 'F. empaque',
        'FechaDeEmpaque': 'Fecha de empaque',
        'Fecha de cosecha': 'F. cosecha',
        'FechaDeCosecha': 'Fecha de cosecha',
        'Código TMU': 'Código TMU',
        'Calibre': 'Calibre',
        'Tipo de fruta': 'Tipo de fruta',
        'Existen elementos asociados a este item': 'Existen elementos asociados a este item',
        'Comentarios': 'Comentarios',
        'CodigoTMU': 'Código TMU',
        'Paletas': 'Paletas',
        'Editar': 'Editar',
        'Flujo de trabajo': 'Flujo de trabajo',
        'Cajas por paleta': 'Cajas por paleta',
        'Fecha de creación': 'F. Creación',
        'Timestamp': 'Timestamp',
        'Estado':'Estado',
        'Productor':'Productor',
        'Archivos':'Archivos',
        'Archivo':'Archivo',
        'Bodega':'Bodega',
        'Fecha de importacion': 'Fecha de importacion',
        'ProductNetWeight': 'P. Neto',
        'ProductTaraWeight': 'P. Tara',
        'PesoBruto': 'Peso Bruto',
        'PesoNeto': 'Peso Neto',
        'PesoTara': 'Peso Tara',
        'Descripcion': 'Descripción',
        'Pais': 'País ',
        'ReporteDePesos': 'Reporte de Pesos',
        'VariantiSemanal': 'Varianti Semanal',
        'VariantesAdminReporte': 'Reporte Varianti',
        'VariantName': 'Variant Name',
        'VariantDescription': 'Variant Description',
        'AsistenteOrsero': 'Asistente Orsero'
    },
};
